import React from 'react';

// Two arrows pointing toward each other between brackets
const MergeIcon = () => (
  <svg
    viewBox='0 0 24 24'
    width='1em'
    height='1em'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.5'
    strokeLinecap='square'
    strokeLinejoin='miter'
    style={{ verticalAlign: '-0.125em' }}
    aria-hidden='true'
  >
    <path d='M8 2.5H5a2.5 2.5 0 0 0-2.5 2.5v14A2.5 2.5 0 0 0 5 21.5h3' />
    <path d='M16 2.5h3a2.5 2.5 0 0 1 2.5 2.5v14a2.5 2.5 0 0 1-2.5 2.5h-3' />
    <path d='M2.5 12H10M7 8.5l3.5 3.5L7 15.5' />
    <path d='M21.5 12H14M17 8.5L13.5 12l3.5 3.5' />
  </svg>
);

export default MergeIcon;
